import { API_URL } from './Api';

export const API_URN = '/v1/permissoes-recebidas';

export function PESQUISA_EMPRESAS(idCorreios) {
  return {
    url: `${API_URL}${API_URN}/${idCorreios}/buscarEmpresas`,
    options: {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${window.localStorage.getItem('token')}`,
      },
    },
  };
}

export function PESQUISA_SISTEMAS_POR_EMPRESA(idCorreios,idCorreiosPJ) {
  return {
    url: `${API_URL}${API_URN}/${idCorreios}/listarSistemaGrupo/${idCorreiosPJ}`,
    options: {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${window.localStorage.getItem('token')}`,
      },
    },
  };
}

export function PESQUISA_CONTRATOS_POR_EMPRESA(idCorreios,idCorreiosPJ) {
  return {
    url: `${API_URL}${API_URN}/${idCorreios}/listarContratos/${idCorreiosPJ}`,
    options: {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${window.localStorage.getItem('token')}`,
      },
    },
  };
}

export function GRUPO_EXCLUIR(idCorreios, idCorreiosPJ, idSistema, idGrupo) {
  return {
    url: `${API_URL}${API_URN}/${idCorreios}/deleteGrupo/${idCorreiosPJ}/${idSistema}/${idGrupo}`,
    options: {
      method: 'DELETE',
      headers: {
        Authorization: `Bearer ${window.localStorage.getItem('token')}`,
      },
    },
  };
}

export function SISTEMA_EXCLUIR(idCorreios, idCorreiosPJ, idSistema) {
  return {
    url: `${API_URL}${API_URN}/${idCorreios}/deleteSistema/${idCorreiosPJ}/${idSistema}`,
    options: {
      method: 'DELETE',
      headers: {
        Authorization: `Bearer ${window.localStorage.getItem('token')}`,
      },
    },
  };
}

export function CARTAO_POSTAGEM_EXCLUIR(idCorreios, idCorreiosPJ, nuContrato, nuSe, nuCartaoPostagem) {
  return {
    url: `${API_URL}${API_URN}/${idCorreios}/deleteCartaoPostagem/${idCorreiosPJ}/${nuContrato}/${nuSe}/${nuCartaoPostagem}`,
    options: {
      method: 'DELETE',
      headers: {
        Authorization: `Bearer ${window.localStorage.getItem('token')}`,
      },
    },
  };
}

export function CENTRO_CUSTO_EXCLUIR(idCorreios, idCorreiosPJ, nuContrato, nuSe, nuCentroCusto) {
  return {
    url: `${API_URL}${API_URN}/${idCorreios}/deleteCentroCusto/${idCorreiosPJ}/${nuContrato}/${nuSe}/${nuCentroCusto}`,
    options: {
      method: 'DELETE',
      headers: {
        Authorization: `Bearer ${window.localStorage.getItem('token')}`,
      },
    },
  };
}

export function CONTRATO_EXCLUIR(idCorreios, idCorreiosPJ, nuContrato, nuSe) {
  return {
    url: `${API_URL}${API_URN}/${idCorreios}/deleteContrato/${idCorreiosPJ}/${nuContrato}/${nuSe}`,
    options: {
      method: 'DELETE',
      headers: {
        Authorization: `Bearer ${window.localStorage.getItem('token')}`,
      },
    },
  };
}